import nightscoutApi from '../../../api/nightscout';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  updateNightscoutUserPassphrase ({ commit }, { context, passphrase, id }) {
    return nightscoutApi.updateNightscoutUserPassphrase(context, passphrase, id);
  },
  updateNightscoutOwnPassphrase ({ commit }, { context, passphrase }) {
    return nightscoutApi.updateNightscoutOwnPassphrase(context, passphrase);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/brand/xugarhero/store/modules/nightscout/index.js